<template>
  <b-container>
    <b-navbar class="bg-white" fixed="top" style="z-index: 999">
      <b-navbar-brand class="text-left" href="/">
        <router-link :to="{ name: 'home' }">
          <img
            class="media-right"
            src="../assets/logo.jpg"
            v-bind:alt="project.brandName"
            width="40%"
          />
        </router-link>
      </b-navbar-brand>

      <!--      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>-->
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <div>
            <b-nav-item>
              <router-link
                active-class="text-underline"
                :to="{ name: 'aboutUs' }"
                class="text-dark"
                v-b-tooltip.hover.bottom
              >
                About us
              </router-link>
            </b-nav-item>
          </div>
          <div>
            <b-nav-item>
              <router-link
                active-class="text-underline"
                :to="{ name: 'whatWeOffer' }"
                class="text-dark"
              >
                What we offer
              </router-link>
            </b-nav-item>
          </div>
          <div>
            <b-nav-item>
              <router-link
                active-class="text-underline"
                :to="{ name: 'OurUsers' }"
                class="text-dark"
              >
                Our users
              </router-link>
            </b-nav-item>
          </div>
          <div class="pt-2 pr-2 pl-1">
            <a
              class="text-dark"
              href="http://recipes.culture-labs.eu/forum/"
              target="_blank"
              >Forum</a
            >
          </div>

          <div>
            <b-nav-item ref="global-search">
              <b-button
                class="bg-orange"
                @click="globalSearch"
                size="sm"
                target="_blank"
              >
                <font-awesome-icon icon="search" />
                Search
              </b-button>
            </b-nav-item>
          </div>

          <div v-if="!authenticatedUser">
            <b-nav-item>
              <router-link :to="{ name: 'login' }" class="text-dark"
                >Login</router-link
              >
            </b-nav-item>
          </div>
          <div v-else>
            <b-nav-item-dropdown class="mt-1" right>
              <template v-slot:button-content>
                <span class="text-dark p-1" id="user-container">
                  <span>{{ user }}</span>
                </span>
              </template>
              <!--              <b-dropdown-item @click="routeToRecipes">-->
              <!--                  <router-link :to="{name: 'recipes'}" class="action-btns">Recipes</router-link>-->
              <!--              </b-dropdown-item>-->
              <!--              <b-dropdown-item @click="routeToResources">-->
              <!--                <router-link :to="{name: 'resources'}" class="action-btns">Resources</router-link>-->
              <!--              </b-dropdown-item>-->
              <!--              <b-dropdown-item @click="routeToOrganizations">-->
              <!--                <router-link :to="{name: 'organizations'}" class="action-btns">Organizations</router-link>-->
              <!--              </b-dropdown-item>-->
              <!--              <b-dropdown-item @click="routeToGroups">-->
              <!--                <router-link :to="{name: 'groups'}" class="action-btns">Groups</router-link>-->
              <!--              </b-dropdown-item>-->
              <!--              <b-dropdown-divider></b-dropdown-divider>-->
              <b-dropdown-item :to="{ name: 'account' }"
                >My profile</b-dropdown-item
              >
              <b-dropdown-item :to="{ name: 'accountEdit' }"
                >Edit profile</b-dropdown-item
              >
              <b-dropdown-item @click.prevent="userLogout"
                >Logout</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </div>
          <div v-if="!authenticatedUser">
            <b-nav-item>
              <router-link :to="{ name: 'signup' }" class="text-dark">
                Sign up
              </router-link>
            </b-nav-item>
          </div>
          
            <b-nav-item v-if="authenticatedUser">
            <NotificationBell/>
            </b-nav-item>
            
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "../main";
import SearchPlugin from "../plugins/SearchPlugin";
// import NotificationFeed from "./notifications/NotificationFeed";
// import NotificationFeedUnhandled from "./notifications/NotificationFeedUnhandled";
import NotificationBell from "./notifications/NotificationBell";
import config from "../../config";

export default {
  components: {  NotificationBell  },
  data() {
    return {
      search: "",
      searchResult: "",
      organisationName: "",
      recipeName: "",
      resourceName: "",
      notificationCount: null,
      allnotificationsAmount: null
    };
  },
  props: {
    project: Object,
  },
  created() {
    eventBus.$on("organisationSearchedName", (data) => {
      this.searchResult = data;
    });
    eventBus.$on("organisationSearchNull", (data) => {
      this.searchResult = data;
    });
    eventBus.$on("forgetGlobalSearch", (data) => {
      this.search = data;
    });
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    user() {
      // get the fullname of the logged in user
      if (Object.keys(this.$store.state.user).length > 0) {
        return this.$store.state.user.name;
      }
      return "";
    },
  },
  beforeMount() {
    SearchPlugin.event.$on("updateterm", this.changeTerm);
    SearchPlugin.event.$on("showView", this.showView);
  },
  methods: {
    globalSearch() {
      this.search = "global";
      this.showAll();
    },
    userLogout(event) {
      // logout user
      this.$store.dispatch("logout");
      this.$router.push({ name: "home" });
    },
    // Search integration addition
    changeTerm(val) {
      this.sTerm = val;
    },
    showAll: function (token) {
      this.$search.toggleSearch();
    },
    showSearch: function () {
      this.$search.toggleSearch();
    },
    showView: function (event) {
      // // alert('View with type: ' + event.detail.type + ' and id: ' + event.detail.id)
      if (this.search === "global") {
        if (event.detail.type === "Organisation") {
          this.$router.push({
            name: "organizationView",
            params: { id: event.detail.id },
          });
          this.search = "";
        } else if (event.detail.type === "Recipe") {
          this.$router.push({
            name: "recipeView",
            params: { id: event.detail.id },
          });
          this.search = "";
        } else if (event.detail.type === "Resource") {
          this.$router.push({
            name: "resourceView",
            params: { id: event.detail.id },
          });
          this.search = "";
        }
      }
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token,
      });
    },
    searchTerm: function (term, resulttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token,
      });
    },
    // Search integration addition
  },
};
</script>

<style>
#notifMenu {
  left: -200px;
}


#user-container {
  border: 2px solid #e24a1f !important;
  border-radius: 5px;
}

.text-underline {
  text-decoration: underline !important;
}

#notifications .p1[data-count]:after {
  position: absolute;
  right: 2%;
  top: -10px;
  content: attr(data-count);
  font-size: 80%;
  padding: 0.4em;
  border-radius: 50%;
  line-height: 1em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue